export default __webpack_public_path__ + "static/media/popup.8174eb69.mp3";